import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import { CheckOption } from '../../../../../../../projects/vendors/src/lib/services/form-helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiBaseService } from '../../../../../../../projects/vendors/src/public-api';


@Component({
    selector: 'app-place-order-filter-dialog',
    templateUrl: './place-order-filter-dialog.component.html',
    styleUrl: './place-order-filter-dialog.component.scss',
    standalone: false
})
export class PlaceOrderFilterDialogComponent {

  @Output() filterChange = new EventEmitter<any>();

  categoryKeyValue = [] as CheckOption[]
  typeKeyValue = [] as CheckOption[]
  searchTagKeyValue = [] as CheckOption[]
  selectedCategory!: string[]
  selectedType!: string[]
  selectedTag!: string[]

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
    categoryKeyValue: CheckOption[],
    typeKeyValue: CheckOption[],
    searchTagKeyValue: CheckOption[],
    selectedFilters: {
      category: string[],
      type: string[],
      searchTag: string[]
    }
  },
    private dialogRef: MatDialogRef<PlaceOrderFilterDialogComponent>) {
    this.categoryKeyValue = this.data.categoryKeyValue;
    this.typeKeyValue = this.data.typeKeyValue;
    this.searchTagKeyValue = this.data.searchTagKeyValue;

    this.selectedCategory = this.data?.selectedFilters.category;
    this.selectedType = this.data?.selectedFilters.type;
    this.selectedTag = this.data?.selectedFilters.searchTag;
  }



  onCategory(selectedCategory: string[]) {
    this.selectedCategory = selectedCategory;
    this.emitFilterData();
  }

  onType(selectedType: string[]) {
    this.selectedType = selectedType;
    this.emitFilterData();
  }

  onSearchTag(selectedTag: string[]) {
    this.selectedTag = selectedTag;
    this.emitFilterData();
  }

  emitFilterData() {
    const filterData = {
      category: this.selectedCategory,
      type: this.selectedType,
      searchTag: this.selectedTag,
    };
    this.filterChange.emit(filterData);
  }

  onSubmit() {
    this.dialogRef.close();
  }


  // onClear() {
  //   this.selectedCategory = [];
  //   this.selectedType = [];
  //   this.selectedTag = [];
  //   const filterData = {
  //     category: this.selectedCategory,
  //     type: this.selectedType,
  //     searchTag: this.selectedTag,
  //   };

  //   this.dialogRef.close();
  // }

}
